import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Contents.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

function Contents({ isOpen5, onClose5, apiKey }) {
  const [country, setCountry] = useState('');
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [videos, setVideos] = useState([]);
  const [showTable, setShowTable] = useState(false);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      기존 H트렌드<br/> 검색정렬과 같게 검색 합니다
    </Tooltip>
  );

  const renderTooltip2 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      특정 국가에 영상이 없으면<br/> 타 국가 및 빈값을 출력할 수 있습니다
    </Tooltip>
  );

  const fetchCategories = async () => {
    try {
      const response = await fetch(`https://www.googleapis.com/youtube/v3/videoCategories?part=snippet&regionCode=${country}&hl=ko&key=${apiKey}`);
      const data = await response.json();
      setCategories(data.items);
    } catch (error) {
      console.error(error);
    }
  };

  const handleResetButtonClick = () => {
    setCountry('');
    setCategories([]);
    setCategoryId('');
    setVideos([]);
    setShowTable(false);
  };
  const fetchSubscribers = async (channelIds) => {
    const subscriberCounts = await Promise.all(channelIds.map(async channelId => {
      try {
        const response = await fetch(`https://www.googleapis.com/youtube/v3/channels?part=statistics&id=${channelId}&key=${apiKey}`);
        const data = await response.json();
        return data.items[0].statistics.subscriberCount;
      } catch (error) {
        console.error(error);
        return 'N/A';
      }
    }));

    return subscriberCounts;
  };

  const fetchVideos = async () => {
    try {
      const response = await fetch(`https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=20&type=video&videoCategoryId=${categoryId}&regionCode=${country}&key=${apiKey}`);
      const data = await response.json();
      const videoIds = data.items.map(video => video.id.videoId).join(',');
  
      const videoDetailsResponse = await fetch(`https://www.googleapis.com/youtube/v3/videos?part=snippet,statistics&id=${videoIds}&key=${apiKey}`);
      const videoDetailsData = await videoDetailsResponse.json();
      const channelIdArray = videoDetailsData.items.map(video => video.snippet.channelId);
  
      const subscriberCounts = await fetchSubscribers(channelIdArray);
      const videosWithSubscribers = videoDetailsData.items.map((video, index) => {
        return { ...video, subscriberCount: subscriberCounts[index] };
      });
  
      if (isHSearchChecked) {
        const sortedVideos = [...videosWithSubscribers].sort((a, b) => {
          const aViews = parseInt(a.statistics.viewCount, 10);
          const bViews = parseInt(b.statistics.viewCount, 10);
          const aSubscribers = parseInt(a.subscriberCount, 10);
          const bSubscribers = parseInt(b.subscriberCount, 10);
  
          const aRatio = aViews / aSubscribers;
          const bRatio = bViews / bSubscribers;
          return bRatio - aRatio;
        });
      
        setVideos(sortedVideos);
      } else {
        setVideos(videosWithSubscribers);
      }} catch (error) {
        console.error(error);
        }
        };

      
  //H검색 구현
  const [isHSearchChecked, setIsHSearchChecked] = useState(false);
  const handleCheckboxChange = (event) => {
  setIsHSearchChecked(event.target.checked);
  fetchVideos();
};
    //
  
  const handleCancelButtonClick = () => {
    
    onClose5();
  };

  const handleCountryChange = (event) => {
    setCountry(event.target.value);
    setCategoryId('');
    if (event.target.value !== '') {
    fetchCategories();
    }
    };
    
    const handleCategoryChange = (event) => {
    setCategoryId(event.target.value);
    };
    
    const handleSearchButtonClick = () => {
    if (categoryId !== '') {
    fetchVideos();
    setShowTable(true);
    }
    };
    
    return (
      <div className={`modal ${isOpen5 ? 'open' : ''}`}>
        <div className="modal-content">
          <div className="modal-header">
            <h2>컨텐츠 분석</h2>
            <button onClick={handleCancelButtonClick} style={{ color: 'black' }}>X</button>
          </div>
          <div className="modal-controls">
            <div>
              <label>국가 선택: </label>
              <select value={country} onChange={handleCountryChange}>
                 <option value="">선택하세요</option>
                <option value="US">미국</option>
                <option value="KR">한국</option>
                <option value="JP">일본</option>
                {/* 다른 국가도 추가할 수 있습니다. */}
              </select>
            </div>
            <div>
              <label>1차 카테고리 선택: </label>
              <select value={categoryId} onChange={handleCategoryChange}>
                <option value="">선택하세요</option>
                {categories.map(category => (
                  <option key={category.id} value={category.id}>{category.snippet.title}</option>
                ))}
              </select>
              <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip2}
    >
              <button onClick={handleSearchButtonClick}>검색</button>
              </OverlayTrigger>
      <button onClick={handleResetButtonClick}>초기화</button>
      
            </div>
            </div>
    <div className="modal-buttons">
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
  <label>
  H검색:
  <input
    type="checkbox"
    onChange={handleCheckboxChange}
  />
</label>
</OverlayTrigger>
    </div>
    {showTable && (
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>썸네일</th>
              <th>제목</th>
              <th>조회수</th>
              <th>구독자 수</th>
              <th>업로드 날짜</th>
            </tr>
          </thead>
          <tbody>
            {videos.map(video => (
              <tr key={video.id}>
                <td>
  <a
    href={`https://www.youtube.com/watch?v=${video.id}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src={video.snippet.thumbnails.default.url}
      alt={video.snippet.title}
    />
  </a>
</td>
                <td>{video.snippet.title}</td>
                <td>{video.statistics.viewCount}</td>
                <td>{video.subscriberCount}</td>
                <td>{new Date(video.snippet.publishedAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
</div>

    );
    }
    
    Contents.propTypes = {
    isOpen5: PropTypes.bool.isRequired,
    onClose5: PropTypes.func.isRequired,
    apiKey: PropTypes.string.isRequired,
    };
    
    export default Contents;
